import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import useBackLayer from '../hooks/useBackLayer';
const { pushStatus, enableWebPush } = require('../utils/notificationTransport');
const { shouldOfferNotifications, rememberNotificationChoice } = require('../utils/notificationOnboarding');
export default function NotificationWelcome({ username }) {
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    pushStatus(username, sessionStorage.getItem('reconnectToken')).then(status => {
      if (active && shouldOfferNotifications(localStorage, username, status)) setOpen(true);
    }).catch(() => {});
    return () => { active = false; };
  }, [username]);
  const later = () => { rememberNotificationChoice(localStorage, username, busy ? 'asked' : 'later'); setOpen(false); };
  useBackLayer(open, later);
  const enable = async () => {
    setBusy(true); setError('');
    // Direct call before the first await keeps the user's permission gesture intact.
    const enabling = enableWebPush(username, sessionStorage.getItem('reconnectToken'));
    rememberNotificationChoice(localStorage, username, 'asked');
    try { await enabling; rememberNotificationChoice(localStorage, username, 'enabled'); setOpen(false); }
    catch (_) { setError('Etkinleştirilemedi. Bildirim ayarlarından tekrar deneyebilirsin.'); }
    finally { setBusy(false); }
  };
  if (!open) return null;
  return <div className="fixed inset-0 z-[90] flex items-end justify-center bg-slate-950/65 p-3 sm:items-center" onKeyDown={event => { if (event.key === 'Escape') later(); }}>
    <section role="dialog" aria-modal="true" aria-label="Telefon bildirimleri" className="kelimo-ui kelimo-sheet w-full max-w-sm rounded-[2rem] bg-white p-6 text-center text-slate-900 shadow-2xl">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600"><Bell size={28} /></span>
      <h2 className="mt-4 text-xl font-black">Sıranı kaçırma</h2><p className="mt-2 text-sm text-slate-600">Sıra sana geldiğinde ve oyun daveti aldığında haber verelim.</p>
      {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
      <button autoFocus type="button" disabled={busy} onClick={enable} className="mt-5 min-h-12 w-full rounded-xl bg-indigo-600 px-4 py-3 font-bold text-white disabled:opacity-50">{busy ? 'Etkinleştiriliyor…' : 'Bildirimleri aç'}</button>
      <button type="button" disabled={busy} onClick={later} className="mt-2 min-h-11 w-full rounded-xl px-4 py-3 font-semibold text-slate-600">{error ? 'Kapat' : 'Şimdi değil'}</button>
    </section>
  </div>;
}
